import './lms.scss'
import { Outlet } from 'react-router-dom'
import RenderOnRole from '../../components/RenderOnRole'
import { LMS_READ } from '../../utils/roles'

const Lms = () => {
  return (
    <RenderOnRole
      roles={[LMS_READ]}
      element={
        <div className='lms-container-div'>
          <div className='lms-content-div'>
            <Outlet />
          </div>
        </div>
      }
    />
  )
}

export default Lms
